'use strict'

module.exports = {}.hasOwnProperty
